import { render, staticRenderFns } from "./BaseCascader.vue?vue&type=template&id=00fd54d4&scoped=true&"
import script from "./BaseCascader.vue?vue&type=script&lang=js&"
export * from "./BaseCascader.vue?vue&type=script&lang=js&"
import style0 from "./BaseCascader.vue?vue&type=style&index=0&id=00fd54d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fd54d4",
  null
  
)

export default component.exports